import $apiJSON from '../http/apiJSON'

// Food API Service

export async function getFoodRestaurants(params = {}) {
  return $apiJSON.get('food/restaurants/', { params })
}

export async function getFoodRestaurant(slug) {
  return $apiJSON.get(`food/restaurants/${slug}/`)
}

export async function getRestaurantMenu(slug) {
  return $apiJSON.get(`food/restaurants/${slug}/menu/`)
}

export async function getFoodCategories() {
  return $apiJSON.get('food/categories/')
}

export async function getFoodItems(params = {}) {
  return $apiJSON.get('food/food-items/', { params })
}

export async function getMenuItems(params = {}) {
  return $apiJSON.get('food/menu-items/', { params })
}

export async function getMenuItem(slug) {
  return $apiJSON.get(`food/menu-items/${slug}/`)
}

export async function addFoodToCart(slug, quantity = 1, options = {}) {
  return $apiJSON.post(`food/menu-items/${slug}/add-to-cart/`, { quantity, ...options })
}

export async function getFoodCart() {
  return $apiJSON.get('food/cart/')
}

export async function updateFoodCart(data) {
  return $apiJSON.put('food/cart/', data)
}

export async function clearFoodCart() {
  return $apiJSON.post('food/cart/clear/')
}

export async function getFoodOrders() {
  return $apiJSON.get('food/orders/')
}

export async function createFoodOrder(data) {
  return $apiJSON.post('food/orders/', data)
}

export async function getFoodOrder(id) {
  return $apiJSON.get(`food/orders/${id}/`)
}

export async function trackFoodOrder(id) {
  return $apiJSON.get(`food/orders/${id}/track/`)
}

export async function cancelFoodOrder(id) {
  return $apiJSON.post(`food/orders/${id}/cancel/`)
}

export async function rateFoodItem(slug, rating, review = '') {
  return $apiJSON.post(`food/menu-items/${slug}/rate/`, { rating, review })
}

export async function getFoodItemReviews(slug) {
  return $apiJSON.get(`food/menu-items/${slug}/reviews/`)
}

export async function getFoodStats() {
  return $apiJSON.get('food/stats/')
}